import React from "react";
import { printHtml } from "../../data/print";

const HardwareSettingsView = ({ onClose }) => {
  return (
    <div className="card shadow-sm border-0 h-100" style={{ backgroundColor: "#1f2937", color: "white" }}>
      <div className="card-header border-bottom-0 pb-0 bg-transparent pt-4 d-flex justify-content-between align-items-center">
        <h5 className="fw-bold m-0"><i className="bi bi-gear-fill me-2"></i> MATÉRIEL & PARAMÈTRES</h5>
        <button className="btn btn-sm btn-outline-light" onClick={onClose}><i className="bi bi-x-lg"></i></button>
      </div>
      <div className="card-body mt-3">
        <div className="bg-dark p-3 rounded border border-secondary mb-3 d-flex justify-content-between align-items-center">
          <div>
            <div className="fw-bold"><i className="bi bi-printer me-2"></i> Imprimante Ticket</div>
            <div className="small text-success">Connectée (via Navigateur)</div>
          </div>
          <button className="btn btn-outline-light btn-sm" onClick={() => {
            printHtml(`
              <div style="text-align:center; padding:20px; font-family:monospace;">
                <h3>TEST D''IMPRESSION</h3>
                <p>L''imprimante fonctionne correctement.</p>
                <p>${new Date().toLocaleString('fr-FR')}</p>
                <p>-------------------------</p>
              </div>
            `);
          }}>Tester</button>
        </div>

        <div className="bg-dark p-3 rounded border border-secondary mb-3 d-flex justify-content-between align-items-center">
          <div>
            <div className="fw-bold"><i className="bi bi-upc-scan me-2"></i> Lecteur Code-barres</div>
            <div className="small text-success">Actif (Mode clavier virtuel)</div>
          </div>
        </div>

        <div className="bg-dark p-3 rounded border border-secondary mb-3 d-flex justify-content-between align-items-center">
          <div>
            <div className="fw-bold"><i className="bi bi-hdd me-2"></i> Tiroir Caisse</div>
            <div className="small text-muted">Couplé à l''imprimante</div>
          </div>
          <button className="btn btn-outline-light btn-sm" onClick={() => {
             printHtml("<html><body></body></html>", { title: "Ouverture tiroir" });
          }}>Ouvrir</button>
        </div>
      </div>
    </div>
  );
};

export default HardwareSettingsView;

